import MainLayout from "@/components/layout/mainLayout";
import About from "./about";

const AboutPage = () => {
    return (
        <MainLayout>
            <About />
        </MainLayout>
    );
}

export default AboutPage;